<template>
  <div id='PriceOverlay' @click='hide()' class="modal fade">
    <div id="content" class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <table class="table table-bordered vartical white">
          <tbody>
            <tr>
              <th colspan="2">入居金型プランa方式Aタイプ</th>
            </tr>
            <tr>
              <th rowspan="2">プラン</th>
              <td>入居金型プラン</td>
            </tr>
            <tr>
              <td>
                【入居金型プランについて】<br>
                 入居金を支払っていただくことで、毎月の利用料負担が少なくなる契約方法です。
              </td>
            </tr>
          </tbody>
        </table>
        <table class="moving_in_table table table-bordered vartical white">
          <tbody>
            <tr>
              <th colspan="3">入居時費用</th>
            </tr>
            <tr>
              <th rowspan="2">入居金</th>
              <td colspan="2"><span class="pricePlanPrice">290</span>万円</td>
            </tr>
            <tr>
              <td colspan="2">
                【入居金について】<br>
                 入居金は、居室および共用施設の家賃相当額の一部、または全部に充当されるものです。5年以内にご退居された場合、ご入居の期間に応じて入居金の一部は返還します。（入居金はご契約時に3割を償却し、残り7割を5年（60ヶ月）均等で償却します。
              </td>
            </tr>
            <tr>
              <th>敷金</th>
              <td colspan="2">-</td>
            </tr>
            <tr>
              <th rowspan="2">返還制度</th>
              <td subhead>入居金初期償却率</td>
              <td>30%</td>
            </tr>
            <tr>
              <td subhead>入居金償却年月数</td>
              <td>60ヶ月</td>
            </tr>
          </tbody>
        </table>
        <table class="monthly_price_table table table-bordered vartical white">
          <tbody>
            <tr>
              <th colspan="3">月額費用</th>
            </tr>
            <tr>
              <th rowspan="9">月額費用</th>
              <td colspan="2"><span class="pricePlanPrice">257,010</span>円（税込）</td>
            </tr>
            <tr>
              <td subhead>家賃</td>
              <td>70,000円</td>
            </tr>
            <tr>
              <td rowspan="2">食材費</td>
              <td>70,000円</td>
            </tr>
            <tr>
              <td>【食材費について】<br>
                  食材費は、1日3食を30日提供の場合です。食材費は軽減税率の対象とし、1食につき640円以下（税抜）の場合は、消費税率8％に基づいて記載しています。
              </td>
            </tr>
            <tr>
              <td rowspan="2">管理費</td>
              <td>146,850円（税込）</td>
            </tr>
            <tr>
              <td>【管理費について】<br>
                  管理費には、施設の維持・管理費、水光熱費、厨房運営費および施設運営管理に関わる人件費等が含まれます。<br>
                  ・上記記載の入居金は、入居時満年齢75歳以上の方が対象となります。満75歳未満の方は、上記記載の金額とは異なりますので別途ご提示させていただきます。
              </td>
            </tr>
            <tr>
              <td rowspan="2">上乗せ介護費用</td>
              <td>11,000円（税込）</td>
            </tr>
            <tr>
              <td>【上乗せ介護費用について】<br>
                当ホームでは介護保険給付基準を上回る、要支援者および要介護者2.5名に対し、常勤換算1名以上の職員体制（週40時間換算）をとっているほか、看護職員を24時間配置しています。この基準を上回る手厚い人員体制分の料金として算出した上乗せ介護費用を頂戴しております。なお、看護職員（看護師または准看護師）を常勤換算（週40時間換算）で2名配置（満床時）。夜間帯（22時～翌6時）最少時の体制は看護職員1名、介護職員3名（満床時）を配置しております（人数はシフト数を記載）。職員体制は、見直しなどにより変更する場合がございます。
              </td>
            </tr>
            <tr>
              <td>生活支援費用</td>
              <td>-</td>
            </tr>
            <tr>
              <td colspan="3">
                【介護度に応じた注意事項】<br>
                自立の方・入居中に自立となった方の場合の月額利用料は、「家賃相当額」「食材費」「管理費」のほか、自立者生活支援費用として1名あたり、月額30,000円（税込33,000円）を加算した金額となります。
              </td>
            </tr>
          </tbody>
        </table>
        <table class="self_pay_table table table-bordered vartical white">
          <tbody>
            <tr>
              <th colspan="3">介護保険自己負担額</th>
            </tr>
            <tr>
              <th></th>
              <td subhead>1割負担</td>
              <td>2割負担</td>
            </tr>
            <tr>
              <th>要支援1</th>
              <td>8,045円</td>
              <td>16,089円</td>
            </tr>
            <tr>
              <th>要支援2</th>
              <td>12,670円</td>
              <td>25,340円</td>
            </tr>
            <tr>
              <th>要介護1</th>
              <td>21,743円</td>
              <td>43,485円</td>
            </tr>
            <tr>
              <th>要介護1</th>
              <td>24,110円</td>
              <td>48,219円</td>
            </tr>
            <tr>
              <th>要介護1</th>
              <td>26,619円</td>
              <td>53,238円</td>
            </tr>
            <tr>
              <th>要介護1</th>
              <td>28,914円</td>
              <td>57,828円</td>
            </tr>
            <tr>
              <th>要介護1</th>
              <td>31,389円</td>
              <td>62,777円</td>
            </tr>
            <tr>
              <td colspan="3">
                【介護保険自己負担額について】<br>
                月額利用料のほか、介護保険自己負担分が毎月かかります。（1ヶ月を30日として算出/1名あたり）<br>
                ・上記の「介護保険自己負担分」の表は、「夜間看護体制加算」「医療機関連携加算」「個別機能訓練加算(Ⅰ)(12単位/日)」「生活機能向上連携加算(Ⅱ)(100単位/月)」「介護職員処遇改善加算」「サービス提供体制強化加算(Ⅰ)(22単位/日)」「入居継続支援加算(Ⅰ)(36単位/日)」「口腔衛生管理体制加算」「介護職員等特定処遇改善加算(Ⅰ)」「ADL維持等加算(Ⅱ)(60単位/月)」「科学的介護推進体制加算」「介護職員等ベースアップ等支援加算」を含めた1割負担額（目安）を表示しております。<br>
                ・要支援の方は「夜間看護体制加算」「入居継続支援加算」「ADL維持等加算」の適用はございません。<br>
                ・要介護の方は「入居継続支援加算」を算定する場合、「サービス提供体制強化加算」は算定できないため上記金額にも含まれておりません。<br>
                ・「看取り介護加算」「退院・退所時連携加算」「個別機能訓練加算(Ⅱ)」「口腔・栄養スクリーニング加算」については、法令に定められた条件を満たした場合、上記の自己負担分の料金に加え算定することがございます。<br>
                実際の自己負担額と異なる場合がありますので、詳細はお問い合わせください。<br>
                ・自己負担割合が2割の場合の自己負担額は、1割の場合の概ね2倍の金額に、3割の場合は、1割の場合の概ね3倍の金額になります。<br>
                ・自己負担割合は介護保険の『負担割合証』でご確認ください。<br>
              </td>
            </tr>
          </tbody>
        </table>
        <table class="table table-bordered vartical white">
          <tbody>
            <tr>
              <th>その他注意事項</th>
            </tr>
            <tr>
              <td>
                ・当ホームは医療機関ではありませんので、入院加療が必要になった場合は医療機関での治療が必要となります。
                <br><br>
                ・ご入居者個人のおむつ代、医療費、嗜好品購入費等は上記料金に含まれていません。
                <br><br>
                ・入居金、敷金、家賃相当額、介護保険自己負担分は非課税です。
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
export default {
  name: 'PricePlanModal',
  mounted() {
    let selectedPriceId = $('#selectedPriceId').data('id')
    //this.$store.commit('map/setSelectedMarkerId', $('#selectedCareHomeId').data('id'))
  },
  components: {},
  data() {
    return {
      care_home: {
        id: null,
        name: null,
        pamphlets: []
      }
    }
  },
  computed: {
    ...mapGetters('map', ['mapSelectedMarkerId']),
  },
  methods: {
    hide() {
      this.$emit('hideModal')
    },
  },
}
</script>
